import React from 'react';
import './aboutus.css';

function AboutOptometry() {
  return (
    <div className="about-optometry-container">
      <h1 className="about-optometry-header">Optometry</h1>
      
      <section className="about-optometry-section">
        <p>
          Optometrists are independent primary health care providers who examine, diagnose, treat, and manage diseases and disorders of the visual system, the eye, and associated structures as well as diagnose related systemic conditions.
        </p>
        <p>
          Optometrists provide a significant percentage of the primary eye care services in Sri Lanka. They are more widely distributed geographically than other eye care providers and are readily accessible for the delivery of eye and vision care services.
        </p>
        <p>
          The mission of the profession of optometry is to fulfil the vision and eye care needs of the public through clinical care, research, and education. During an examination, an Optometrist also assesses general health conditions. The diagnosis of systemic manifestations of ocular disease is necessary to preserve and enhance the patient's quality of life. When appropriate, the optometrist refers patients to other health care professionals and frequently works with them in co-managing the patient's condition.
        </p>
        <p>
          Those who choose optometry enjoy challenging and rewarding careers. The type of practice setting which the optometrist may enter is also expanding. While private solo practice is still the predominant mode of practice, more optometrists are entering into partnerships or group practices with other optometrists or other health care providers. Health maintenance organizations, institutes, and research offer further opportunities.
        </p>
      </section>

      <section className="career-opportunities">
        <h2>Multiple Career Opportunities</h2>
        <ul>
          <li>Optical</li>
          <li>Eye unit/Hospital</li>
          <li>Multi-national ophthalmic companies</li>
          <li>Non-Government Organisations</li>
          <li>Occupational Counselling</li>
          <li>Teaching/Research</li>
        </ul>
      </section>

      <section className="advantages">
        <h2>Advantages of a Career in Optometry</h2>
        <div>
          <h3>Income</h3>
          <p>
            The healthcare profession is one of the most rewarding and impactful career paths, offering the opportunity to make a real difference in people's lives. 
            It is widely regarded as one of the ten best income-earning professions, combining financial stability with personal fulfillment. 
            Professionals in this field play a crucial role in improving community health, advancing medical knowledge, and providing essential care and support to those in need. 
            With continuous advancements in medical technology and growing demand for skilled practitioners, healthcare remains a dynamic and ever-evolving profession.
          </p>

        </div>
        <div>
          <h3>Prestige</h3>
          <p>
            As providers of an essential health care service, Optometrists are highly regarded in their communities. They experience the satisfaction of helping people preserve or improve the precious gift of sight.
          </p>
        </div>
        <div>
          <h3>Flexibility</h3>
          <p>
            Despite being a respectable profession in the medical field, Optometrists have limited working hours and few emergencies, enabling them to easily integrate their personal lives with their professional responsibilities.
          </p>
        </div>
        <div>
          <h3>Job Security</h3>
          <p>
            With shortages currently existing in the country, Optometrists have the opportunity to choose their own location. The need for vision care in our health-conscious society is high as the population ages. Opportunities in Optometry will continue to grow. The demand for Optometrists greatly outnumbers the limited supply, and this scenario is not likely to change for the next decade.
          </p>
        </div>
      </section>
    </div>
  );
}

export default AboutOptometry;
